export default __webpack_public_path__ + "static/avatar-67880367ae58878d13fc12559e49d800.jpg";